import React, { useEffect, useState } from "react";
import "../StuStyles/JobStrategy.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../../../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

const JobStrategy = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalApplied, setTotalApplied] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ search: "", status: "" });

  useEffect(() => {
    fetchAppliedJobs();
  }, []);

  const fetchAppliedJobs = async () => {
    try {
      setLoading(true);

      const response = await JobAPI.getStudentAppliedJobs();

      console.log("APPLIED JOBS FULL RESPONSE :", response);
      console.log("APPLIED JOBS DATA :", response?.data);

      let applications = [];

      if (Array.isArray(response?.data)) {
        applications = response.data;
      } else if (Array.isArray(response?.data?.applications)) {
        applications = response.data.applications;
      } else if (Array.isArray(response?.data?.data)) {
        applications = response.data.data;
      } else if (Array.isArray(response?.data?.results)) {
        applications = response.data.results;
      } else {
        applications = [];
      }

      console.log("EXTRACTED APPLICATIONS :", applications);
      console.log("TOTAL COUNT :", applications.length);

      setTotalApplied(applications.length);

      const formattedData = applications.map((item, index) => ({
        id: item?.id || `APP-${index}`,
        jobId: item?.job_id || item?.jobId || "",
        appliedFor:
          item?.position_applied_for ||
          item?.job_title ||
          item?.title ||
          "N/A",
        companyName: item?.company_name || item?.company || "N/A",
        location: item?.location || "N/A",
        experience: item?.experience || item?.experience_type || "Fresher",
        status: item?.status || "Pending",
        appliedDate: item?.created_at || "",
        jobData: item,
      }));

      console.log("FORMATTED DATA :", formattedData);

      setData(formattedData);
      setFilteredData(formattedData);
    } catch (error) {
      console.log("APPLIED JOBS ERROR :", error);
      console.log("ERROR RESPONSE :", error?.response?.data);
      console.log("ERROR STATUS :", error?.response?.status);

      toast.error(
        error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "Failed to load applied jobs"
      );

      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GET STATUS INLINE STYLE
  ========================================================= */
  const getStatusStyle = (status) => {
    const base = {
      padding: "5px 14px",
      borderRadius: "20px",
      fontWeight: "600",
      fontSize: "13px",
      display: "inline-block",
    };

    const s = (status || "").toLowerCase();

    if (s === "shortlisted") {
      return {
        ...base,
        backgroundColor: "#d4edda",
        color: "#155724",
        border: "1px solid #c3e6cb",
      };
    } else if (s === "rejected") {
      return {
        ...base,
        backgroundColor: "#f8d7da",
        color: "#721c24",
        border: "1px solid #f5c6cb",
      };
    } else if (s === "pending") {
      return {
        ...base,
        backgroundColor: "#fff3cd",
        color: "#856404",
        border: "1px solid #ffeeba",
      };
    } else {
      return {
        ...base,
        backgroundColor: "#e2e3e5",
        color: "#383d41",
        border: "1px solid #d6d8db",
      };
    }
  };

  const applyFilters = () => {
    const filtered = data.filter((item) => {
      const matchSearch =
        !filters.search ||
        item?.appliedFor
          ?.toLowerCase()
          .includes(filters.search.toLowerCase());
      const matchStatus =
        !filters.status ||
        item?.status?.toLowerCase() === filters.status.toLowerCase();
      return matchSearch && matchStatus;
    });
    setFilteredData(filtered);
    setSelectedRows([]);
  };

  const handleCheck = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    setSelectedRows(
      selectedRows.length === filteredData.length
        ? []
        : filteredData.map((x) => x.id)
    );
  };

  const handleDelete = async () => {
    try {
      if (!selectedRows.length) {
        toast.warning("Please select applications");
        return;
      }
      const remaining = filteredData.filter(
        (item) => !selectedRows.includes(item.id)
      );
      setFilteredData(remaining);
      setData(remaining);
      setTotalApplied(remaining.length);
      setSelectedRows([]);
      toast.success("Applications removed from view");
    } catch (error) {
      console.log("DELETE ERROR :", error);
      toast.error("Delete failed");
    }
  };

  const handleViewJob = (item) => {
    navigate(`/student/jobs/${item.jobId}`, {
      state: { job: item.jobData },
    });
  };

  return (
    <div className="stu-container">
      <ToastContainer />

      <h1 className="stu-title">Job Strategy</h1>

      {/* TOTAL APPLIED */}
      <div
        style={{
          background: "#0d1b4c",
          color: "#fff",
          padding: "15px",
          borderRadius: "10px",
          marginBottom: "20px",
          width: "260px",
          textAlign: "center",
        }}
      >
        <h3 style={{ margin: "0 0 8px 0", fontSize: "16px" }}>
          Total Jobs Applied
        </h3>
        <h1 style={{ margin: "0", fontSize: "42px", fontWeight: "700" }}>
          {totalApplied}
        </h1>
      </div>

      {/* FILTERS */}
      <div className="stu-filters-box">
        <input
          type="text"
          placeholder="Search Job Title"
          className="stu-filter-input"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />

        <select
          className="stu-filter-input"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="">All Status</option>
          <option value="Pending">Pending</option>
          <option value="Shortlisted">Shortlisted</option>
          <option value="Rejected">Rejected</option>
        </select>

        <button className="stu-apply-btn" onClick={applyFilters}>
          Apply
        </button>

        <button className="stu-delete-btn" onClick={handleDelete}>
          Delete
        </button>
      </div>

      {/* LOADING */}
      {loading && (
        <div
          style={{ textAlign: "center", marginTop: "40px", fontSize: "16px" }}
        >
          <h4>Loading Applied Jobs...</h4>
        </div>
      )}

      {/* TABLE */}
      {!loading && (
        <div className="stu-table-box">
          <table className="stu-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={selectAll}
                    checked={
                      selectedRows.length === filteredData.length &&
                      filteredData.length > 0
                    }
                  />
                </th>
                <th>Applied For</th>
                <th>Company</th>
                <th>Location</th>
                <th>Experience</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(item.id)}
                        onChange={() => handleCheck(item.id)}
                      />
                    </td>
                    <td>{item.appliedFor}</td>
                    <td>{item.companyName}</td>
                    <td>{item.location}</td>
                    <td>{item.experience}</td>
                    <td>
                      <span style={getStatusStyle(item.status)}>
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="stu-view-btn"
                        onClick={() => handleViewJob(item)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="stu-no-data"
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    No Applications Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default JobStrategy;